import React, { useState } from "react";
import { apiClient } from "src/api/apiService";
import { Dashboard } from "src/templates";
import ActionSectionResponsive from "./ActionSection";
import ContentSectionResponsive from "./ContentSection";
import { FeedProvider } from "src/context/Feed";
import { onFetchNextPageProps } from "src/context/Feed/types";
import {
  mapProjectsResponseToRows,
  NewProject,
  ProjectSortByEnum,
  ProjectsResponse,
} from "src/components/Projects";
import { PageTitleSection } from "./PageTitleSection";

export const Projects: React.FC = () => {
  const [open, setOpen] = useState(false);

  const closeDialog = () => {
    setOpen(false);
  };

  const openDialog = () => {
    setOpen(true);
  };

  const handleFetchNextPage = async ({
    searchTerm,
    page,
    sortConfig,
  }: onFetchNextPageProps) => {
    const response = await apiClient.get<ProjectsResponse>("/project", {
      params: {
        page,
        limit: 10,
        sortDirection: sortConfig.direction,
        sortBy: sortConfig.key,
        searchTerm: searchTerm?.trim() || undefined,
      },
    });
    return {
      newData: mapProjectsResponseToRows(response.data.projects),
      isEOL: response.data.projects.length === 0,
    };
  };

  return (
    <FeedProvider
      onFetchNextPage={handleFetchNextPage}
      initialState={{
        sortConfig: { key: ProjectSortByEnum.NAME, direction: "ASC" },
      }}
    >
      <Dashboard
        pageTitleSection={<PageTitleSection />}
        actionSection={<ActionSectionResponsive openDialog={openDialog} />}
        data-id="projectsDashboard"
      >
        <ContentSectionResponsive />
        {/* End Actions container */}
        {open && <NewProject closeDialog={closeDialog} />}
      </Dashboard>
    </FeedProvider>
  );
};
